import React from "react";

const DeveloperInfoSection = () => {
  return (
    <div className="max-w-5xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">About Developer</h2>

      {/* Developer Card */}
      <div className="bg-gray-100 p-6 rounded-lg flex justify-between items-center">
        <div>
          <h3 className="text-xl font-semibold">Vardhman Group</h3>
          <p className="text-gray-600">Years of Experience - <span className="font-bold">42</span></p>
        </div>
        <img 
          src="https://img.staticmb.com/mbimages/photo_dir/developer/original_images/65451/1738140931970-VG-logo.png" 
          alt="Vardhman Group Logo" 
          className="w-20 h-20 object-cover rounded-full border"
        />
      </div>

      {/* Project Details */}
      <div className="mt-4 bg-white p-4 rounded-lg shadow-md border">
        <div className="grid grid-cols-2 border-b pb-2">
          <p className="text-gray-600">Total Projects</p>
          <p className="font-bold text-gray-800">20</p>
        </div>
        <div className="grid grid-cols-2 border-b py-2">
          <p className="text-gray-600">Projects Completed</p>
          <p className="font-bold text-gray-800">10</p>
        </div>
        <div className="grid grid-cols-2 border-b py-2">
          <p className="text-gray-600">Projects Ongoing</p>
          <p className="font-bold text-gray-800">2</p>
        </div>
        <div className="grid grid-cols-2 pt-2">
          <p className="text-gray-600">Operating in</p>
          <p className="font-bold text-blue-600">Beyond Thane, Mumbai, Navi Mumbai +6</p>
        </div>
      </div>

      {/* Description */}
      <p className="mt-4 text-gray-600">
        The word <span className="font-bold">"VARDHMAN"</span> means ever increasing. To us, at Vardhman Group, it means growth for all. 
        Vardhman is a company whose philosophy lies in the commi... 
        <a href="#" className="text-red-600 font-medium hover:underline">Read More</a>
      </p>
    </div>
  );
};

export default DeveloperInfoSection;
